import type React from 'react';
import { useFieldContext } from '../FormContext';
import styles from './ColorField.module.css';

export const ColorField: React.FC = () => {
  const { field, value, onChange } = useFieldContext();

  if (field.type !== 'color') {
    throw new Error('ColorField can only be used with color field type');
  }

  return (
    <div>
      <label className="label" htmlFor={field.name}>
        {field.label}
      </label>
      {field.description && (
        <p className="description">{field.description}</p>
      )}
      <input
        id={field.name}
        type="color"
        value={value || field.defaultValue || '#000000'}
        onChange={(e) => onChange(e.target.value)}
        className={styles.colorInput}
      />
    </div>
  );
};
